import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import { useDeleteDataLakeBackend } from "data-lake/data-lake-backend-config/hooks/useDataLakeBackendMutation";
const DeleteDataLakeAction = ({ backend }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const { mutateAsync: deleteBackend } = useDeleteDataLakeBackend();
  const onDeleteSubmit = () => {
    deleteBackend(backend.id).catch(() => void 0).finally(() => {
      setShowConfirmDelete(false);
    });
  };
  const onDelete = () => {
    setShowConfirmDelete(true);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "data_lake_backend_config:delete" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: onDelete }, t("delete_action.button"))), showConfirmDelete && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      title: t("delete_action.title", { title: backend.title }),
      show: true,
      onConfirm: onDeleteSubmit,
      onCancel: () => setShowConfirmDelete(false)
    },
    /* @__PURE__ */ React.createElement("p", null, t("delete_action.text", { title: backend.title }))
  ));
};
export default DeleteDataLakeAction;
